import Api from '@/modules/core/api/api.ts';
import { AUTO_REPLACES_GET } from '@/modules/core/configs/end-points.ts';
import { TEMPLATE_AUTOCORRECT_COUNT, USER_AUTOCORRECT_COUNT } from '@/modules/control/consts/autocorrect.const.ts';
import { defineStore } from 'pinia';
import { StoreId } from '@/modules/common/enums/store-id.enum.ts';

export interface AutocorrectReplace {
  FAV_ID: number;
  Замена: string;
  [key: string]: unknown;
}

interface AutocorrectReplaceOption {
  label: string;
  code: number;
}

interface State {
  usersAutocorrect: number[];
  autocorrectReplaces: number[];
  autocorrectReplacesSelect: AutocorrectReplace[];
}

export const useAutocorrectStore = defineStore(StoreId.Autocorrect, {
  state: (): State => ({
    usersAutocorrect: [],
    autocorrectReplaces: [],
    autocorrectReplacesSelect: [],
  }),
  getters: {
    autocorrectReplaceSelectGetter(state): AutocorrectReplaceOption[] {
      const select: AutocorrectReplaceOption[] = [];
      for (const n in state.autocorrectReplacesSelect) {
        select.push({
          label: state.autocorrectReplacesSelect[n]['Замена'],
          code: state.autocorrectReplacesSelect[n]['FAV_ID'],
        });
      }
      return select;
    },
    autocorrectReplaceObjListGetter(state): Record<number, AutocorrectReplace> {
      const obg: Record<number, AutocorrectReplace> = {};
      for (const n in state.autocorrectReplacesSelect) {
        obg[state.autocorrectReplacesSelect[n]['FAV_ID']] = state.autocorrectReplacesSelect[n];
      }
      return obg;
    },
  },
  actions: {
    addUserAutocorrect(userId: number) {
      if (userId > 0 && !this.usersAutocorrect.includes(userId)) {
        this.usersAutocorrect.unshift(userId);
        this.usersAutocorrect = this.usersAutocorrect.slice(0, USER_AUTOCORRECT_COUNT);
      }
    },
    delUserAutocorrect(userId: number) {
      this.usersAutocorrect = this.usersAutocorrect.filter((v) => v !== userId);
    },
    addReplaceAutocorrect(favId: number) {
      if (favId > 0 && !this.autocorrectReplaces.includes(favId)) {
        this.autocorrectReplaces.unshift(favId);
        this.autocorrectReplaces = this.autocorrectReplaces.slice(0, TEMPLATE_AUTOCORRECT_COUNT);
      }
    },
    delReplaceAutocorrect(favId: number) {
      this.autocorrectReplaces = this.autocorrectReplaces.filter((v) => v !== favId);
    },
    async setAutocorrectReplacesSelectAction(data: { limit: number }) {
      if (!this.autocorrectReplacesSelect?.length) {
        return await Api.post(AUTO_REPLACES_GET, data).then((response: { items: AutocorrectReplace[] }) => {
          this.autocorrectReplacesSelect = response.items;
        });
      }
    },
  },
  persist: true,
});
